import * as yup from 'yup';
import { MAXIMUM_COMMENT_LENGTH } from '@common/types/constants.ts';

export const clinicCaptionSchema = yup.object().shape({
  clinical_caption: yup
    .string()
    .optional()
    .max(
      MAXIMUM_COMMENT_LENGTH,
      `This input must be ${MAXIMUM_COMMENT_LENGTH} characters or less. Please reduce the length to proceed.`,
    ),
});
